export default "__VITE_ASSET__xj4MXAPV__"